import Eev from 'eev';

export const EventEmitter = new Eev();

export const loadScript = (src, attrs) => {
    var script = document.createElement('script');
    script.src = src;

    if (attrs && attrs.length > 0) {
        for (var i in attrs) {
            var attr = attrs[i];
            var name = attr.name;
            var value= attr.value;
            script.setAttribute(name, value);
        }
    }

    var wrapper = document.body ? document.body:document.head;
    wrapper.appendChild(script);
}

export const loadStyle = (href, attrs) => {
    var css = document.createElement('link');
    css.setAttribute('rel', 'stylesheet');
    css.setAttribute('type','text/css')
    css.setAttribute('href', href);

    if (attrs && attrs.length > 0) {
        for (var i in attrs) {
            var attr = attrs[i];
            var name = attr.name;
            var value= attr.value;
            css.setAttribute(name, value);
        }
    }

    document.head.append(css);
}

export const registerApp = (zones, page, accoutId, condition) => {
    if (condition) {
        loadScript(`${PUBLIC_PATH}/${page}_${accoutId}_${zones}.bundle.js`);
        $.get(`${PUBLIC_PATH}/${page}_${accoutId}_${zones}.css`).done(() => loadStyle(`${PUBLIC_PATH}/${page}_${accoutId}_${zones}.css`));
    }
}

export const get_crm_account_id = () => {
    const loc = window.location.href;
    const reg      = new RegExp(/^(acct_)\d+/i);

    const CRM_ACCOUNT_IDs = document.body.className.split(' ')
                    .filter( name => reg.test(name));

    return CRM_ACCOUNT_IDs[0];
}

export const checkRealTimeProductInventory = (productId, dest) => {

    return $.ajax({
        type: "get",
        url: "/site/productinventory/realtimeInventory.xml",
        data: `productId=${productId}`,
        dataType: "xml",
        cache: true
    })
}